export const menuTitle = { title: "ACADEMY", label: "Academy" }
  